import React from 'react'
import Typography from '@material-ui/core/Typography/Typography'
import { t } from '../../commons/Translate.js'

const NotFound = () => (
  <div style={{ padding: 24 }}>
    <Typography variant="body1">{t('In Entwicklung...')}</Typography>
  </div>
)

export default NotFound
